// Déclaration de type pour dataLayer
declare global {
    interface Window {
        dataLayer: Array<{ event: string;[key: string]: unknown }>;
    }
}

export default function initNav(): void {
    const $navContainer = document.querySelectorAll<HTMLElement>('.js-main-header');

    $navContainer.forEach($container => {
        new Nav($container);
    });
}

class Nav {
    $body: HTMLElement | null | undefined;
    $el: HTMLElement | null | undefined;
    $superHeader: HTMLElement | null | undefined;
    $navLogo: HTMLElement | null | undefined;
    $mainNavElements: HTMLElement | null | undefined;
    navBreakpoint: number;
    lastScrollTop: number;

    constructor($el: HTMLElement | null) {

        this.$body = document.querySelector('body');
        this.lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        this.$el = $el;
        this.$superHeader = document.querySelector('.super-header') as HTMLElement;
        this.$navLogo = document.querySelector('.nav-logo') as HTMLElement;
        this.$mainNavElements = document.querySelector('.main-nav-elements') as HTMLElement;
        this.navBreakpoint = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-nav'));
        window.addEventListener('resize', this.onWindowResize.bind(this));
        window.addEventListener('scroll', this.windowScroll.bind(this));
        this.onWindowResize();
        this.toggleMenu();
        this.gaEventHandler();
    }

    getScrollDirection(currentScrollTop: number): string {
        // const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const direction = this.lastScrollTop < currentScrollTop ? 'down' : 'up';
        this.lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop; // For Mobile or negative scrolling
        return direction;
    }

    applyPositioning(): void {
        if (this.$superHeader && this.$mainNavElements) {
            const superHeaderHeight = this.$superHeader.offsetHeight;
            // const navLogoHeight = this.$navLogo.offsetHeight;
            // this.$navLogo.style.top = `${superHeaderHeight}px`;
            if (window.innerWidth < this.navBreakpoint) {
                // this.$mainNavElements.style.top = `${superHeaderHeight + navLogoHeight}px`;
                this.$mainNavElements.style.minHeight = `calc(100vh - ${superHeaderHeight + 135}px)`;
            } else {
                this.$mainNavElements.style.minHeight = '0px';
            }
        }
    }


    onWindowResize(): void {
        if (window.innerWidth < this.navBreakpoint) {
            this.$el?.classList.add('header-mobile');

        } else if (window.innerWidth > this.navBreakpoint) {
            this.$el?.classList.remove('header-mobile');
            this.$el?.classList.remove('main-header--active');
        }

        this.applyPositioning();
    }

    toggleMenu(): void {
        const $burgerBtn = this.$el?.querySelector('.js-burger-btn');


        $burgerBtn?.addEventListener('click', () => {
            this.$el?.classList.toggle('main-header--active');
            this.$body?.classList.toggle('prevent-scroll');

            if (this.$el?.classList.contains('submenu-active')) {
                this.$el?.classList.remove('submenu-active');
            }


            if (this.$el?.classList.contains('main-header--active')) {
                const $elementWithSubmenus = this.$el.querySelectorAll('.nav-submenu:not(:has(.nav-link-solo))');


                $elementWithSubmenus.forEach(el => {
                    el.addEventListener('click', () => {
                        this.$el?.classList.toggle('submenu-active');
                        el.classList.toggle('submenu-is-active');

                        const links = el.querySelectorAll('.nav-link');
                        links.forEach(link => {
                            link.addEventListener('click', () => {
                                this.$el?.classList.remove('main-header--active');
                            })
                        })
                    })
                })
            }
        });
    }

    windowScroll() {
        const superHeaderHeight = this.$superHeader?.offsetHeight || 0;
        const windowScroll = document.body.scrollTop || document.documentElement.scrollTop;
        const scrollDirection = this.getScrollDirection(windowScroll);

        if (windowScroll > 1) {
            this.$el?.classList.add('header-on-scroll');
            if (scrollDirection === 'down') {
                if (this.$el) {
                    this.$el.style.top = `-${superHeaderHeight}px`;
                }
            } else {
                if (this.$el) {
                    this.$el.style.top = '0px';
                }
            }
        } else {
            this.$el?.classList.remove('header-on-scroll');
        }
    }

    gaEventHandler() {
        if (this.$superHeader) {
            const gaLink = this.$superHeader.querySelector('.push a');



            if (gaLink) {
                gaLink.addEventListener('click', () => {
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        'event': 'click_bandeau_header'
                    });
                })
            }

        }
    }
}
